import React, { useEffect, useState } from 'react';
import { useRouteMatch } from "react-router-dom";
//ACTIONS AND CONTEXT
import { useMainContext } from "../../../contexts/MainContext";
//COMPONENTS
import ButtonModalFiles from '../../molecules/ButtonModalFiles';
//ASSETS
import ventasImg from '../../../assets/icons/icon-ventas.svg';
import ventasWhiteImg from '../../../assets/icons/icon-ventas-white.svg';
import homeImg from '../../../assets/icons/icon-home.svg';
import Dropdown from '../../atoms/Dropdown';
import './style.css';

const MenuDemand = ({ linkActive, phaseID, phaseData, hasUnits }) => {
    let mainContext = useMainContext();
    let { path } = useRouteMatch();

    const [phaseName, setPhaseName] = useState("");

    useEffect(() => {
        mainContext.setIsDirty(false);
    }, []);

    useEffect(() => {
        if (phaseData.phaseID)
            setTitle();
        else
            createTitle();
    }, [phaseData]);

    const setTitle = () => {
        let name = "COMPLEJO - NUEVA TORRE";
        if (phaseData.developerComplex)
            name = phaseData.developerComplex.complex.complexName;
        name += " - " + phaseData.phaseName;
        setPhaseName(name);
    }

    const createTitle = () => {
        let name = "COMPLEJO - NUEVA TORRE";
        if (phaseData.complexID)
            name = phaseData.complexID.complexName;
        if (phaseData.complexID)
            name += " - " + phaseData.phaseName;
        setPhaseName(name);
    }

    const requestNavigation = (goTo) => {
        let goToArr = goTo.split("/");
        let pathArr = path.split("/");
        if (goToArr[goToArr.length - 1] == pathArr[pathArr.length - 1])
            return;
        if (phaseID || goTo === "/#home")
            mainContext.setGoTo(goTo);
    }

    //Menu
    const getCSSClass = (link) => {
        let _className = "";
        if (linkActive == link)
            _className += "active-tab ";
        if (!phaseID)
            _className += "disabled";
        //_className = "btn btn-white mr-3 btn-submenu ";

        return _className;
    }

    return (
        <>
            <div className="row">
                <h2 className="col py-5 break-word">{phaseName}</h2>

                <div className="col contentSelectProfileGeneral">
                    <p>Servicio 4S</p>
                    <Dropdown value={{ label: "Demanda", value: 1 }} options={[{ label: "Demanda", value: 1 }, { label: "Oferta", value: 2 }]} optionLabel="label" optionValue="value" classNamePrefix="dropdown"/>
                    <ButtonModalFiles phaseID={phaseID} projectID={(phaseData.projects) ? phaseData.projects.projectID : null} />
                </div>
            </div>
            <div className="row mb-5">
                <div className="col col-8">
                    <div className={`nav nav-fill`} style={{ width: '17em' }}>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#demand/general") }} className={`nav-link pointer ${getCSSClass("general")}`} data-cy="link-status"><span>General</span></a>
                        </div>
                        <div className="nav-item">
                            <a onClick={() => { requestNavigation("/#demand/importer") }} className={`nav-link pointer ${getCSSClass("importer")}`} data-cy="link-status"><span>Importaciones</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MenuDemand;